import React from 'react';
import fullPic from "../../Assets/images/affiliator_and_tenderpublish/Asset 7.png"

const Affiliator = () => {
  return (
    <div className="container mx-auto md:py-10 py-6">
      <h1 className="text-center font-bold md:text-2xl text-xl">
        Work With Us As Affiliator & Gain Your{' '}
        <span className="text-ServiceIconColor">Financial Freedom</span>
      </h1>
      <img src={fullPic} alt="" className='w-full'/>
    </div>
  );
};

export default Affiliator;





// import React from 'react';
// import menPic from "../../Assets/images/affiliator_and_tenderpublish/Tenderwise landing page ai_2.png";
// import BackgroundImage from "../../Assets/images/affiliator_and_tenderpublish/BG BLUE.png";
// import BGText from "../../Assets/images/affiliator_and_tenderpublish/Asset 6.png";

// const Affiliator = () => {
//   return (
//     <div
//       className="relative min-h-screen bg-cover bg-center flex items-center justify-center"
//       style={{ backgroundImage: `url(${BackgroundImage})` }}
//     >
//       {/* Container for Images */}
//       <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-8">
//         {/* Left Image */}
//         <img
//           src={menPic}
//           alt="Men"
//           className="w-full max-w-xs md:max-w-md lg:max-w-lg h-auto"
//         />

//         {/* Right Image */}
//         <img
//           src={BGText}
//           alt="Background Text"
//           className="w-full max-w-xs md:max-w-md lg:max-w-lg h-auto"
//         />
//       </div>
//     </div>
//   );
// };

// export default Affiliator;